// ============================================================
// KONFIGURASI SITUS — cukup ubah nilai di file ini.
// ============================================================
export const SITE = {
  name: "PT. Prime Karya Mandiri",
  tagline: "Kontraktor Konstruksi & Renovasi",

  // Nomor WhatsApp bisnis (format internasional tanpa '+').
  whatsappNumber: "6285603838383",
  whatsappDisplay: "0856-0383-8383",
  whatsappMessage:
    "Halo PT. Prime Karya Mandiri, saya ingin berkonsultasi mengenai kebutuhan proyek saya.",

  // Kosongkan ("") bila belum ada — website menampilkan penanda "Segera tersedia".
  address: "Summarecon Bekasi, Jawa Barat",
  workingHours: "09.00 – 16.00",
  email: "primekaryamandiri@gmail.com",
  socials: {
    instagram: "",
    facebook: "",
    linkedin: "",
  },
};

export const waLink = `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(
  SITE.whatsappMessage,
)}`;
